<template>
  <div class="_feed">
    <div class="_feed_item" v-for="(_item, index) in items" :key="index">
      <Change
        v-if="'change' == _item._type"
        :item="_item"
      />
      <Comment
        v-if="'comment' == _item._type"
        :comment="_item"
        :commentId="taskId"
        :userListItems="userListItems"
        :task="task"
      />
    </div>
  </div>
</template>

<script>
import Change from "@/components/DynamicForm/Change";
import Comment from "@/components/DynamicForm/Comment";

export default {
  components: {
    Change,
    Comment
  },
  props: {
    taskId: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    userListItems: {
      type: Array,
      default: []
    },
    task: {
      type: Object,
      required: false
    }
  },
};
</script>

<style scoped>
</style>
